module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_plan_show_bg_05-6d4873bd188bf53e47506b65ccb522a0.png";